<template>
  <div class="contact-bar-wrapper">
    <div class="teaser" v-if="loginVisible">
      <div
        style="font-size: 24px; font-weight: bold; width: 100%; margin: 10px 0"
      >
        krankenkassenzertifizierte & bezuschusste Sportkurse
      </div>
    </div>

    <div class="contact-bar">
      <div class="hidden-xs" v-if="loginVisible">
        <img
          :src="`https://ik.imagekit.io/eyesonly/tr:w-48,fl-h/${imageKitStage}/Sahra%20Theraband`"
          alt="Sahra Weber - Personal Trainer"
        />
      </div>

      <div class="contact-data">
        <div class="hidden-xs" v-if="loginVisible">
          <div>Sahra Weber</div>
          <div>Diplom Sportwissenschaftlerin</div>
        </div>

        <div class="contact-links">
          <div>
            <i class="fa fa-envelope"></i>
            <a href="mailto:info@sahra-weber.de?subject=Kontaktanfrage"
              >info@sahra-weber.de</a
            >
          </div>
          <div>
            <i class="fa fa-phone"></i>
            <a href="tel:+491778737773">0177 / 87 37 773</a>
          </div>
        </div>

        <div>
          <table>
            <tbody>
              <tr>
                <td><i class="fa fa-clock-o"></i></td>
                <td>Mo-Do</td>
                <td>10-18 Uhr</td>
              </tr>
              <tr>
                <td></td>
                <td>Fr</td>
                <td>10-15 Uhr</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="action-buttons">
        <div class="online-login" v-if="loginVisible">
          <a
            class="btn btn-warning btn-lg"
            title="Zum Onlinekurs-Kundenportal"
            href="/onlinekurs"
          >
            <i class="fa fa-user-circle"></i> Login
          </a>
        </div>

        <div class="flex-row" v-else>
          <div class="switch-participant" v-if="switchParticipantVisible">
            <button-spinner
              :is-spinning="isSwitching"
              class="btn btn-warning btn-sm"
              title="Teilnehmer wechseln"
              @click="resetParticipant"
            >
              <i class="fa fa-exchange"></i>
              Kurs wechseln
            </button-spinner>
          </div>

          <div class="online-logout" v-if="logoutVisible">
            <a
              class="btn btn-warning btn-sm"
              title="abmelden"
              href="/onlinekurs/logout"
            >
              <i class="fa fa-power-off"></i>
              Abmelden
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  loginRoute,
  participantSelectionRoute,
  requestNewPasswordRoute,
} from '../../OnlineCourse/hooks/useRoutes';
import { setUser, getUser } from '../../OnlineCourse/hooks/useOnlineAuth';
import ButtonSpinner from '../../../components/ButtonSpinner.vue';
import { getImageKitStage } from '../hooks/useImageKitStage';

export default {
  name: 'ContactBar',
  components: { ButtonSpinner },
  data() {
    return {
      isSwitching: false,
    };
  },
  computed: {
    imageKitStage() {
      return getImageKitStage();
    },
    loginVisible() {
      return !this.includedInPath(['/onlinekurs']);
    },
    logoutVisible() {
      const exclusions = [loginRoute, requestNewPasswordRoute];

      return !this.loginVisible && !this.includedInPath(exclusions);
    },
    switchParticipantVisible() {
      if (!this.logoutVisible) {
        return false;
      }

      if (this.includedInPath([participantSelectionRoute])) {
        return false;
      }

      const user = getUser();

      return (
        this.isSwitching ||
        user.isAdminLogin ||
        (!!user?.participantId && user?.totalNumberOfParticipants > 1)
      );
    },
  },
  methods: {
    includedInPath(paths) {
      if (!this.$route) {
        return false;
      }

      return paths.some((path) => this.$route.href?.indexOf(path) !== -1);
    },
    resetParticipant() {
      this.isSwitching = true;

      setUser({
        ...getUser(),
        participantId: null,
        conceptId: null,
        cycleId: null,
      });

      this.$router.push(participantSelectionRoute);

      setTimeout(() => {
        this.isSwitching = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-bar-wrapper {
  margin: 0 0 4px;
  padding: 0;
  position: relative;
  z-index: 1;

  .teaser {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 4px;
    text-align: center;
  }

  .contact-bar {
    align-items: center;
    background-color: var(--background-color-light);
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    color: var(--text-color-invert);
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: normal;
    justify-content: space-between;
    margin: 0;
    padding: 4px 12px;
    row-gap: 10px;
    text-align: center;
    width: 100%;

    @media screen and (min-width: 34rem) {
      flex-direction: row;
    }

    img {
      border: 1px solid var(--color-cta-border);
      border-radius: 10%;
      width: 48px;
    }

    .contact-data {
      align-items: center;
      display: flex;
      flex: 1;
      gap: 12px;
      justify-content: space-around;
      margin: 0 12px;
      text-align: center;

      i {
        margin-right: 4px;
      }

      .contact-links {
        display: flex;
        flex-direction: column;
        justify-content: center;

        > div {
          align-items: center;
          display: flex;
          justify-content: center;
        }

        a {
          align-items: center;
          border: none;
          display: inline-flex;
          min-height: 28px;
          padding: 4px 6px;
          text-decoration: underline;
        }
      }
    }

    table td {
      padding: 0 1px;

      &:nth-child(2) {
        text-align: right;
      }
    }
  }

  .online-login {
    a {
      padding: 6px 10px;
    }
  }

  .online-logout {
    padding: 0 8px;

    a {
      align-items: center;
      display: flex;
    }

    i {
      margin-right: 4px;
    }
  }

  .switch-participant .btn {
    white-space: nowrap;
  }
}
</style>
